import type { ComponentType, SVGProps } from "react";
import type { RecordKind } from "../types";
import { AppointmentIcon, ExerciseIcon, VitalsIcon, WeightIcon } from "./Icons";

const icons: Record<RecordKind, ComponentType<SVGProps<SVGSVGElement>>> = {
  weight: WeightIcon,
  vitals: VitalsIcon,
  exercise: ExerciseIcon,
  appointment: AppointmentIcon,
};

export function RecordKindIcon({ kind, className = "size-4" }: { kind: RecordKind; className?: string }) {
  const Icon = icons[kind];
  return <Icon className={className} />;
}
